'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/company/react/build/packages/react/react.js
 ** module id = 102
 ** module chunks = 2
 **/